var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28718_21338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5625H0.96875C0.84443 14.5625 0.725201 14.5131 0.637294 14.4252C0.549386 14.3373 0.5 14.2181 0.5 14.0938V1.4375H1.4375V13.625H15.5V14.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.6875H2.375V11.75C6.0575 11.75 7.13516 9.37859 8.27656 6.86844C9.43344 4.32266 10.745 1.4375 15.0312 1.4375H15.5V12.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28718_21338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.8598cbfdc03984d9d67b76e7f38a296d.svg";
export { ForwardRef as ReactComponent };